import React, { useState } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import Topbar from '../../layouts/Topbar'
import Sidebar from '../../layouts/Sidebar'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { API_BASE_URL } from '../../../config/api'

const COOChangePassword = () => {
  const baseUrl = API_BASE_URL
  const [form, setForm] = useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
  })
  const [loading, setLoading] = useState(false)
  const [showOld, setShowOld] = useState(false)
  const [showNew, setShowNew] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!form.old_password || !form.new_password || !form.confirm_password) {
      toast.error('All fields are required.')
      return
    }
    if (form.new_password !== form.confirm_password) {
      toast.error('New password and confirm password do not match.')
      return
    }
    setLoading(true)
    try {
      const token = Cookies.get('token')
      await axios.post(
        `${baseUrl}/api/change-password/`,
        {
          old_password: form.old_password,
          new_password: form.new_password,
          confirm_password: form.confirm_password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )
      toast.success('Password changed successfully.')
      setForm({ old_password: '', new_password: '', confirm_password: '' })
    } catch (err) {
      toast.error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          'Failed to change password.',
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      data-sidebar-skin="dark"
      data-header-skin="light"
      data-navbar-brand-skin="dark"
      data-sidebar-state="expand"
    >
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Topbar />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content pb-0">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
            <div>
              <h4 className="fw-bold mb-1">Change Password</h4>
              <p className="text-muted mb-0 fs-13">Update your account security password</p>
            </div>
          </div>

          <div className="card shadow-sm mb-4">
            <div className="card-header bg-light border-bottom py-3">
              <h6 className="card-title mb-0 fw-bold text-dark">Password Management</h6>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="old_password" className="form-label fw-medium">
                    Old Password <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-light text-muted">
                      <i className="ti ti-key" />
                    </span>
                    <input
                      type={showOld ? 'text' : 'password'}
                      id="old_password"
                      name="old_password"
                      value={form.old_password}
                      onChange={handleChange}
                      className="form-control"
                      autoComplete="current-password"
                      disabled={loading}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowOld((v) => !v)}
                      disabled={loading}
                    >
                      <i className={`ti ti-${showOld ? 'eye-off' : 'eye'}`} />
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="new_password" className="form-label fw-medium">
                    New Password <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-light text-muted">
                      <i className="ti ti-lock" />
                    </span>
                    <input
                      type={showNew ? 'text' : 'password'}
                      id="new_password"
                      name="new_password"
                      value={form.new_password}
                      onChange={handleChange}
                      className="form-control"
                      autoComplete="new-password"
                      disabled={loading}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowNew((v) => !v)}
                      disabled={loading}
                    >
                      <i className={`ti ti-${showNew ? 'eye-off' : 'eye'}`} />
                    </button>
                  </div>
                </div>

                <div className="mb-4">
                  <label htmlFor="confirm_password" className="form-label fw-medium">
                    Confirm New Password <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-light text-muted">
                      <i className="ti ti-lock-check" />
                    </span>
                    <input
                      type={showConfirm ? 'text' : 'password'}
                      id="confirm_password"
                      name="confirm_password"
                      value={form.confirm_password}
                      onChange={handleChange}
                      className="form-control"
                      autoComplete="new-password"
                      disabled={loading}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowConfirm((v) => !v)}
                      disabled={loading}
                    >
                      <i className={`ti ti-${showConfirm ? 'eye-off' : 'eye'}`} />
                    </button>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary d-inline-flex align-items-center gap-2"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span>Changing...</span>
                    </>
                  ) : (
                    <>
                      <i className="ti ti-check fs-18" />
                      <span>Change Password</span>
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="footer d-flex align-items-center justify-content-between flex-column flex-sm-row row-gap-2 border-top py-2 px-3">
          <p className="text-dark mb-0">
            2026 © <span className="link-primary">Casoe Technologies</span>, All Rights
            Reserved
          </p>
        </div>
      </div>
    </div>
  )
}

export default COOChangePassword
